import { render, staticRenderFns } from "./BorderSelector.vue?vue&type=template&id=2ec7f4dd&scoped=true"
import script from "./BorderSelector.vue?vue&type=script&lang=js"
export * from "./BorderSelector.vue?vue&type=script&lang=js"
import style0 from "./BorderSelector.vue?vue&type=style&index=0&id=2ec7f4dd&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ec7f4dd",
  null
  
)

export default component.exports